import fetchJSON from '../fetchJSON';

const url = 'https://api.geocode.earth/v1/';

export default {
    async reverse(l: [number, number]) {
        const key = Gaia.peliasApiKey;
        const endpoint = `${url}reverse?point.lat=${l[1]}&point.lon=${l[0]}&api_key=${key}`;
        const response = await fetchJSON(endpoint);
        const output = response.features[0].properties.name || false;
        return output;
    }
};
